export default "__VITE_ASSET__TIt2OzOp__"